import React from "react";
import Email from "../images/Email.svg";
import Password from "../images/Password.svg";

export default function CustomCheckbox({
  text,
  required = false,
  value,
  setValue,
  error = null,
  viewMode,
  name,
  padding = true,
}) {
  const onChange = (e) => {
    //console.log(e.target.checked);
    setValue(e.target.checked);
  };
  return (
    <div className={`relative  ${padding ? "pb-5" : ""}`}>
      <label className="flex mb-0">
        <input
          name={name}
          disabled={viewMode}
          checked={value}
          type={"checkbox"}
          value={value === 1 ? true : false}
          className={`w-4 h-4 mr-2`}
          required={required}
          onChange={onChange}
        />
        {
          <p className="text-blue font-medium text-xs tracking-[-.35px] text-black  cursor-pointer">
            {text}
          </p>
        }
      </label>
      {error ? (
        <div className="w-full absolute left-0 bottom-0 flex items-center pointer-events-none overflow-hidden h-4">
          <div className="text-center">
            <p className="text-red-600 h-[20px] text-[12px] tracking-tight font-medium">
              {error}
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
}
